import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: any) => ({
  container: {
    gridColumn: '4',
    gridRow: '2',
    display: 'flex',
    alignItems: 'flex-end',
  },
  openBtn: {
    padding: '0',
    border: 'none',
    background: 'none',
    cursor: 'pointer',
    textDecoration: 'underline',
    color: theme.lightCoralColor,
    fontFamily: theme.fontFamilyArchivo,
    fontSize: '0.8rem',
    outline: 'none',
  },
  content: (props: any) => ({
    position: 'absolute',
    top: '-1rem',
    left: 0,
    display: props.open ? 'flex' : 'none',
    flexDirection: 'column',
    justifyContent: 'space-around',
    alignItems: 'center',
    width: '100%',
    height: 'calc(100% + 1rem)',
    padding: '0.5rem 0',
    color: theme.whiteColor,
    backgroundColor: theme.darkSlateGrayColor,
    opacity: 0.6,
  }),
  btns: {
    display: 'flex',
    flexDirection: 'row',
    gap: '2.7rem',
  },
  btn: {
    cursor: 'pointer',
  },
  link: {
    textDecoration: 'underline',
    color: 'unset',
  },
}));

export default useStyles;
